exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table th[data-v-4ef6ab48]{background-color:#f8f9fa;position:sticky;top:0;z-index:10}.product-master-matrix thead tr:nth-child(2) th[data-v-4ef6ab48]{top:33px}", ""]);

// exports
